<template>
    <div style="overflow:hidden;">
        <v-container class="achievement">
            <div class="image-p">
                <v-layout row wrap>
                  <v-flex x12 style="">
                  <div style="display:flex;align-items:center;">
                      <v-btn small icon dark @click="$router.go(-1)">
                        <v-icon style="color:#10aa85;">arrow_back</v-icon>
                      </v-btn>
                      <h2 class="fw400" style="color:#10aa85;" v-if="$route.params.id">{{ $route.query.title}}</h2>
                      <h2 class="fw400" style="color:#10aa85;" v-else>Statistik Tryout</h2>
                  </div>
                  </v-flex>
              </v-layout>
            </div>
        </v-container>

        <div v-if="error" style="padding: 15px; margin-top: 15%;">
          <v-layout row wrap >
              <v-flex xs12 style="text-align:center;">
              <img src="@/assets/icon/achievement/img_errorsystem.png" alt="image-alt"/>
              <p style="color:#8E9196;">
                  Duh, kamu belum bisa lihat Capaian Kamu nih, karena sedang ada kesalahan di sistem kami. Kami akan infokan kalo sudah bisa diakses ya!
              </p>
              </v-flex>
          </v-layout>
        </div>

        <div style="display:flex; margin-top: 10%; justify-content:center; align-items:center;" v-if="listChart.length == 0 && loading && !error">
            <!-- <div class="loader" v-if="loading"> -->
            <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
            <!-- </div> -->
        </div>
        <div v-if="listChart.length != 0 && !loading && !error">

          <div v-for="(item, index) in listChart" :key="index">
            <v-container>
                <v-layout row wrap>
                    <v-flex style="display:flex; align-items:flex-end; justify-content:flex-start; padding-bottom: 20px; flex-wrap: inherit;">
                        <h3 style="color:#355EAB; margin-right:10px;">{{ item.name}}</h3>
                        <div>
                            <h4 style="color:#8E9196;font-weight:normal;">Rata-rata:
                            <b style="color:#3CB54A;">{{ item.average_score}}</b></h4>
                        </div>
                    </v-flex>
                    <v-flex>
                        <line-chart :datachart="item.scores" :titlename="item.name" v-on:showDialog="popupdialog($event, item)"></line-chart>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-divider></v-divider>
            </div>
        </div>

      <v-dialog v-model="popupModel"  max-width="350px">
      <v-card style="padding:15px; border-radius: 8px; text-align:center;display:flex; justify-content:center; flex-flow:column;align-items:center;">
        <h2 style="color:#355EAB;">
          {{popupRenderData.titlename}}
        </h2>
        <p style="margin-bottom: 0px;font-size: 18px; color:#8E9196;">
          {{popupRenderData.name}}
        </p>
        <p style="font-size: 18px; color:#8E9196">
          {{popupRenderData.date | converting()}}
        </p>
        <div style="margin-bottom: 20px;padding:10px; border-radius: 26px; background-color:#F9F9F9;width:100px; display:flex; align-items:center; justify-content:center;">
          <p style="font-size: 30px; color: #3CB54A; font-weight: bold; margin-bottom: 0px;">
            {{popupRenderData.score}}
          </p>
        </div>
        <button @click="detailHasil(popupRenderData.group_id)" style="color: #355EAB; font-weight:bold; font-size: 15px; text-decoration: none; cursor: pointer; text-align:center; padding-top:10px;">Lihat Detail</button>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="toastNotif"
      :bottom="true"
      :timeout="3000"
      dark
      color="black"
    >
      <p class="snackbar-p">Terjadi kesalahan, tidak dapat mengambil data</p>
    </v-snackbar>
    </div>
</template>
<style>
.info-icon {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-end;
  float: right;
  cursor: pointer;
}
  .achievement {
    margin-bottom: 0px;
    display: flex;
    align-items: flex-start;
    background-color: white;
    background-size: 100%;
    padding: 1em;
    justify-content: space-between;
    box-shadow: 2px 0px 4px 0px lightgray;
  }

  #seeDetail .v-btn__content{
    text-transform: capitalize !important;
  }
</style>
<script>
import LineChart from '@/components/Achievement/LineChart'
import RadarChart from '@/components/Achievement/RadarChart'
import InfoDialog from '@/components/Achievement/InfoDialog'
import Summary from '@/components/Achievement/SummaryComp'
import moment from 'moment/src/moment'

export default {
  name: 'capaian-kamu',
  data () {
    return {
      infoD: false,
      loading: false,
      error: false,
      queryFilter: '',
      categoryFilter: '',
      listChart: [],
      toastNotif: false,
      popupRenderData: {
        titlename: '',
        name: '',
        date: null,
        score: null,
        group_id: null
      },
      popupModel: false
    }
  },
  components: {
    'line-chart': LineChart,
    'radar-chart': RadarChart,
    'info-dialog': InfoDialog,
    'summary-component': Summary
  },
  filters: {
    converting (date) {
      let toint = moment.unix(date).format('DD-MM-YYYY')
      return '(' + toint + ')'
    }
  },
  mounted () {
    if (this.$route.name == 'statistik-achievement') {
      this.queryFilter = this.$route.query.type
      this.getData()
    } else {
      this.queryFilter = this.$route.query.type
      this.categoryFilter = this.$route.query.category
      this.getDataScore()
    }
  },
  methods: {
    detailHasil (item) {
      localStorage.identifier = item + '_0000000000000'
      this.$store.dispatch('funcGetDetailResult', item + '_0000000000000').then((response) => {
        let gg = response.data
        gg.title = response.data.name
        gg.identifier = response.data.result_identifier
        sessionStorage.setItem('groupResults', JSON.stringify([gg]))
        this.$router.push('/result/' + item + '?achieve=true')
      }).catch(err => {
        this.toastNotif = true
      })
    },
    getData () {
      this.loading = true
      this.$store.dispatch('funcGetTryoutChart', this.queryFilter).then((response) => {
        this.listChart = response.data.data
        this.loading = false
      }).catch(err => {
        if (err.message == 'Request failed with status code 304') {
          let UID = sessionStorage.getItem('UID')
          let lcst = JSON.parse(localStorage.getItem('achievement-' + UID))
          let ss = lcst.detail_statistik[this.queryFilter]
          this.listChart = ss.data
        } else {
          this.error = true
        }
        if (err) {}
        this.loading = false
      })
    },
    getDataScore () {
      this.loading = true
      this.$store.dispatch('funcGetScoreChart', [this.queryFilter, this.categoryFilter]).then((response) => {
        this.listChart = response.data.data
        this.loading = false
      }).catch(err => {
        if (err.message == 'Request failed with status code 304') {
          let UID = sessionStorage.getItem('UID')
          let lcst = JSON.parse(localStorage.getItem('achievement-' + UID))
          let ss = lcst.detail_score_statistik[this.queryFilter + '_' + this.categoryFilter]
          this.listChart = ss.data
        } else {
          this.error = true
        }
        if (err) {}
        this.loading = false
      })
    },
    popupdialog (item, selectedList) {
      this.popupModel = true
      this.popupRenderData = {
        titlename: selectedList.name,
        name: item.name,
        date: item.date,
        score: item.score,
        group_id: item.group_id
      }
    }
  }
}
</script>
